import { render, staticRenderFns } from "./VirtualUsers.vue?vue&type=template&id=665178fb&"
import script from "./VirtualUsers.vue?vue&type=script&lang=js&"
export * from "./VirtualUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports